import {API_DRIVER} from "../configs/axios";

export const ConsipService = {
    fetchIsCustomerConsip: (customerId) => {
        return API_DRIVER.get(`/api/consip/is-consip-customer/${customerId}`)
    },
    fetchOrdiniConsipList: (customerId) => {
        return API_DRIVER.get(`/api/consip/orders/customer/${customerId}`)
    },
    fetchSimDaAttivare: (customerId,sort,page, size,msisdn,iccId) => {
        return API_DRIVER.get(`/api/consip/orders/offerte/sim-list-da-attivare`, {
            params: {
                customerId,
                sort,
                page,
                size,
                msisdn,
                iccId,
            }
        })
    },
    fetchConsipDetailsHeader: (customerId, idTrattativa) => {
        return API_DRIVER.get(`/api/consip/orders/header/customer/${customerId}/id-trattativa/${idTrattativa}`)
    },
    fetchConsipDetailsOfferta: (customerId, idTrattativa) => {
        return API_DRIVER.get(`/api/consip/orders/offerte/customer/${customerId}/id-trattativa/${idTrattativa}`)
    },
    fetchOfferteRowDetails: (customerId, idTrattativa, commercialLabel) => {
        return API_DRIVER.get(`/api/consip/get-options-for-plan/customer/${customerId}/id-trattativa/${idTrattativa}/commercial-label/${commercialLabel}`)
    },
    fetchConsipPlanByServiceType: (consipPlansDto) => {
        return API_DRIVER.post("/api/consip/offerte/da-attivare/plan-list", consipPlansDto)
    },
    fetchSimPrimariaTableData: (customerId, msisdn, iccid, page, size, sort) => {
        return API_DRIVER.get(`/api/consip/offerte/da-attivare/sim-primaria-list`, {
                params: {
                    customerId,
                    msisdn,
                    iccid,
                    page,
                    size,
                    sort
                }
            })
    },
    fetchSimSecondariaSummary: (customerId, iccid) => {
        return API_DRIVER.get(`/api/consip/offerte/da-attivare/sim-secondaria-summary/customerId/${customerId}/iccid/${iccid}`)
    },
    attivaSimSecondariaRequest: (dtoBody) => {
        return API_DRIVER.post(`/api/consip/offerte/da-attivare/sim-secondaria-attivazione`, dtoBody)
    }
}